let isRender = false;
let fontSelected = null;
let spanTextPreview = null;

let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container');
  if (apElements){
    if (!isRender) {
      // Create a span to show preview customer's custom text.
      spanTextPreview = document.createElement('span');
      spanTextPreview.innerHTML = 'Preview your custom text';
      spanTextPreview.setAttribute('id', 'apo-text-preview');  
      spanTextPreview.style.marginLeft = '0.35rem';      
      $('.apo-font').after(spanTextPreview); // prepend a span before add charge message
      isRender = true;
    }
    
    // Hide preview custom text if add charge message not visible
    let isVisiableAddChargeMessage = $('#avp-productoption-total-add').is(':visible');
    if (isVisiableAddChargeMessage) {
    	spanTextPreview.style.display = 'unset';
    } else {
      spanTextPreview.style.display = 'none';
    }
    
    // Capture customer text value and put it in a span
    let customerCustomText = document.querySelectorAll('input[name="properties[Custom Text]"]')[0];
    if (customerCustomText) {
      spanTextPreview.innerHTML = customerCustomText.value;

      // Check which font the customer is choosing to change accordingly
      let optionChooseFonts = document.querySelectorAll('input[name="properties[Font Type:]"]');
      if (optionChooseFonts) {
        for (let optionChooseFont of optionChooseFonts) {
          if (optionChooseFont.checked && spanTextPreview) {
            fontSelected = optionChooseFont.value;
            if (fontSelected === 'Elegant') {
              spanTextPreview.style.cssText = 'font-family:Halimun !important';
            } else if (fontSelected === 'Modern') {
              spanTextPreview.style.cssText = 'font-family:Solver South Serif !important';
            }
          }
        }
      }
    }
  }
}, 100);

let interval4 = setInterval(function () {
  let isCartPage = window.location.pathname.indexOf('cart')
  $('.shopify-payment-button').css('display', 'none');
  $('.additional_checkout_buttons.additional-checkout-buttons--vertical').css('display', 'none')
  clearInterval(interval4);
}, 100)
  